
const createImage = (url: string) =>
	new Promise<HTMLImageElement>((resolve, reject) => {
		const image = new Image()
		image.addEventListener('load', () => resolve(image))
		image.addEventListener('error', (error) => reject(error))
		image.setAttribute('crossOrigin', 'anonymous') // needed to avoid cross-origin issues on CodeSandbox
		image.src = url
	})

export async function getRotatedImage(imageSrc: any, rotation = 0) {
	const image: HTMLImageElement = await createImage(imageSrc)
	const canvas = document.createElement('canvas')
	const ctx: CanvasRenderingContext2D | null = canvas.getContext('2d')

	const orientationChanged =
		rotation === 90 || rotation === -90 || rotation === 270 || rotation === -270
	if (orientationChanged) {
		canvas.width = image.height
		canvas.height = image.width
	} else {
		canvas.width = image.width
		canvas.height = image.height
	}

	if (ctx) {
		ctx.translate(canvas.width / 2, canvas.height / 2)
		ctx.rotate((rotation * Math.PI) / 180)
		ctx.drawImage(image, -image.width / 2, -image.height / 2)
	}

	return new Promise((resolve) => {
		canvas.toBlob((file) => {
			if (file) {
				resolve(URL.createObjectURL(file))
			}
		}, 'image/png')
	})
}
export function readFile(file: any) {
	return new Promise((resolve) => {
		const reader = new FileReader()
		reader.addEventListener('load', () => resolve(reader.result), false)
		reader.readAsDataURL(file)
	})
}
function getRadianAngle(degreeValue: number) {
	return (degreeValue * Math.PI) / 180
}
function rotateSize(width: number, height: number, rotation: number) {
	const rotRad = getRadianAngle(rotation)

	return {
		width:
		Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
		height:
		Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height),
	}
}
export async function getCroppedImg(
	imageSrc: string,
	pixelCrop: any,
	rotation = 0,
	flip = { horizontal: false, vertical: false }
	): Promise<File> {
	const image = await createImage(imageSrc)
	const canvas = document.createElement('canvas')
	const ctx = canvas.getContext('2d')
	
	if (!ctx) {
	//   return null
		return new File(['blob'], 'failed-image.jpg')
	}
	
	const rotRad = getRadianAngle(rotation)
	
	// calculate bounding box of the rotated image
	const { width: bBoxWidth, height: bBoxHeight } = rotateSize(
		image.width,
		image.height,
		rotation
	)
	
	// set canvas size to match the bounding box
	canvas.width = bBoxWidth
	canvas.height = bBoxHeight
	
	// translate canvas context to a central location to allow rotating and flipping around the center
	ctx.translate(bBoxWidth / 2, bBoxHeight / 2)
	ctx.rotate(rotRad)
	ctx.scale(flip.horizontal ? -1 : 1, flip.vertical ? -1 : 1)
	ctx.translate(-image.width / 2, -image.height / 2)
	
	// draw rotated image
	ctx.drawImage(image, 0, 0)
	
	const croppedCanvas = document.createElement('canvas')
	
	const croppedCtx = croppedCanvas.getContext('2d')
	
	if (!croppedCtx) {
	//   return null
		return new File(['blob'], 'failed-image.jpg')
	}
	
	// Set the size of the cropped canvas
	croppedCanvas.width = 512 // pixelCrop.width
	croppedCanvas.height = 512 // pixelCrop.height
	
	// Draw the cropped image onto the new canvas
	croppedCtx.drawImage(
		canvas,
		pixelCrop.x,
		pixelCrop.y,
		pixelCrop.width,
		pixelCrop.height,
		0,
		0,
		512, // pixelCrop.width,
		512 // pixelCrop.height
	)
	
	// As Base64 string
	// return croppedCanvas.toDataURL('image/jpeg');
	
	// As a blob
	return new Promise((resolve, reject) => {
		croppedCanvas.toBlob((file) => {
		if (file) {
			croppedCanvas.toBlob((blob) => {
				if (blob) {
					// let newFile = new File([blob], "fileName.jpg", { type: "image/jpeg" })
					resolve(new File([blob], "fileName.jpg", { type: "image/jpeg" }))
				}
				}, 'image/jpeg');
			// resolve(URL.createObjectURL(file))
		}
		}, 'image/jpeg')
	})
}